import {Button, Container, Row} from "../components/common";
import {CBAction, CBBody, CBHeader, CBPasswordBox, ContentBox} from "../components/common/ContentBox";
import KeyIcon from "../../images/icon_key.png";
import {useEffect, useState} from "react";
import {changePassword, listUserPasswordPolicy} from "../services/api/profileApi";
import {useHistory} from "react-router-dom";
import {runApi} from "../services/api/ApiContext";
//import {clearAllSessions} from "../services/api/sessionApi";
import {toast} from "react-toastify";
import {useProfile} from "../contexts/ProfileContext";

const defaultState = {
    password: '',
    newPassword: '',
    confirmPassword: '',
};

const ChangePasswordView = () => {
    const history = useHistory();
    const [passwords, setPasswords] = useState(defaultState);
    const [policy, setPolicy] = useState(null);

    const profileContext = useProfile();
    const profile = profileContext?.data;

    useEffect(() => {
        async function listFromApi() {
            const listUserPasswordPolicyResponse = await runApi(
                'listUserPasswordPolicy',
                () => listUserPasswordPolicy()
            );
            console.log(listUserPasswordPolicyResponse?.data?.data);
            if (listUserPasswordPolicyResponse?.data?.data) {
                const policy = listUserPasswordPolicyResponse.data.data;
                setPolicy(policy?.settings?.password);
            }
        }

        listFromApi();
    }, []);


    const onChange = (field, value) => {
        const newState = {...passwords};
        newState[field] = value;

        setPasswords(newState);
    }

    const onValidate = (passwords) => {
        let status = true;

        if (!passwords.password) {
            toast.error("Current password cannot be empty.");

            status = false;

            return status;
        }

        if (!passwords.newPassword) {
            toast.error("New password cannot be empty.");

            status = false;

            return status;
        }

        if (!passwords.confirmPassword) {
            toast.error("Confirm New password cannot be empty.");

            status = false;

            return status;
        }

        if (passwords.newPassword.length < policy.complexity.minLength) {
            toast.error("New password needs at least " + policy.complexity.minLength + " characters.");
            status = false;
        }

        if (policy.complexity.minLowerCase > 0 && !/[a-z]/.test(passwords.newPassword)) {
            toast.error("New password needs at least one lowercase letter.");
            status = false;
        }

        if (policy.complexity.minUpperCase > 0 && !/[A-Z]/.test(passwords.newPassword)) {
            toast.error("New password needs at least one uppercase letter.");
            status = false;
        }

        if (policy.complexity.minNumber > 0 && !/[0-9]/.test(passwords.newPassword)) {
            toast.error("New password needs at least one number.");
            status = false;
        }

        let symbols = /[$&+,:;=?@#|'<>.^*()%!-]/;
        if (policy.complexity.minSymbol > 0 && !symbols.test(passwords.newPassword)) {
            toast.error("New password needs at least one symbol.");
            status = false;
        }

        if (profile.firstName && policy.complexity.excludeAttributes.includes("firstName")) {
            if (passwords.newPassword.toLowerCase().indexOf(profile.firstName.toLowerCase()) > -1) {
                toast.error("New password cannot contain parts of your first name.");
                status = false;
            }
        }

        if (profile.lastName && policy.complexity.excludeAttributes.includes("lastName")) {
            if (passwords.newPassword.toLowerCase().indexOf(profile.lastName.toLowerCase()) > -1) {
                toast.error("New password cannot contain parts of your last name.");
                status = false;
            }
        }

        if (profile.electronicId && policy.complexity.excludeUsername) {
            const userNameWords = profile.electronicId.split(/[^a-zA-Z0-9]/);
            const userNameParts = userNameWords.filter((x) => x.length >= 4);

            userNameParts.forEach(function (item) {
                if (passwords.newPassword.toLowerCase().indexOf(item.toLowerCase()) > -1) {
                    toast.error("New password cannot contain parts of your username.");
                    status = false;
                }
            })
        }

        if (passwords.newPassword && passwords.confirmPassword && passwords.newPassword !== passwords.confirmPassword) {
            toast.error("New password and Confirm New Password don't match.");

            status = false;

        }

        return status;
    }

    const onSubmit = async (event) => {
        event.preventDefault();

        const password = {...passwords};

        if (!onValidate(password)) {
            return;
        }

        setPasswords(defaultState);

        const changePasswordResponse = await runApi(
            'changePassword',
            () => changePassword(password.password, password.newPassword, password.confirmPassword),
        );

        if (!changePasswordResponse?.data?.status) {
            return;
        }

        //console.log(await clearAllSessions());
        toast.success("Password changed successfully.");
        history.push("/");
    }

    const onClear = (event) => {
        event.preventDefault();

        setPasswords(defaultState);
    }

    const confirmFail = passwords.newPassword !== passwords.confirmPassword;

    return (
        <Container>
            <h1>Change Password</h1>

            <Row>
                <div className={'col-12 col-lg-6'}>
                    <form>
                        <ContentBox>
                            <CBHeader icon={KeyIcon} title={'Change Password'}/>
                            <CBBody>
                                {policy && <div>
                                    <div className="red-note">
                                        <p>Password requirements:</p>
                                        <ul>
                                            {policy?.complexity?.minLength &&
                                            <li>At least {policy.complexity.minLength} characters </li>}
                                            {policy?.complexity?.minLowerCase !== 0 && <li>A lowercase letter</li>}
                                            {policy?.complexity?.minUpperCase !== 0 && <li>An uppercase letter</li>}
                                            {policy?.complexity?.minNumber !== 0 && <li>A number</li>}
                                            {policy?.complexity?.minSymbol !== 0 && <li>A symbol</li>}
                                            {policy?.complexity?.excludeUsername && <li>No parts of your username</li>}
                                            {policy?.complexity?.excludeAttributes && policy.complexity.excludeAttributes.includes("firstName") &&
                                            <li>Does not include your first name</li>}
                                            {policy?.complexity?.excludeAttributes && policy.complexity.excludeAttributes.includes("lastName") &&
                                            <li>Does not include your last name</li>}
                                            {policy?.age?.historyCount && <li>Your password cannot be any of your
                                                last {policy.age.historyCount} passwords</li>}
                                            {(policy?.age?.maxAgeDays !== 0 || policy?.age?.minAgeMinutes !== 0) &&
                                            <li>At
                                                least {policy?.age?.maxAgeDays !== 0 ? policy?.age?.maxAgeDays + " day(s)" : ""} {policy?.age?.minAgeMinutes !== 0 ? policy?.age?.minAgeMinutes + " minute(s)" : ""} must
                                                have elapsed since you last changed your password</li>}
                                        </ul>
                                    </div>
                                    <div className="col-12">
                                        <CBPasswordBox name={'Current Password'} value={passwords.password}
                                                       onChange={(event) => onChange('password', event.target.value)}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <CBPasswordBox name={'New Password'} value={passwords.newPassword}
                                                       onChange={(event) => onChange('newPassword', event.target.value)}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <CBPasswordBox name={'Confirm New Password'} value={passwords.confirmPassword}
                                                       onChange={(event) => onChange('confirmPassword', event.target.value)}
                                                       fail={confirmFail ? 'Confirm new password is required' : null}
                                        />
                                    </div>

                                    <CBAction>
                                        <Button type={'submit'} onClick={(event) => onSubmit(event)}>Change
                                            Password</Button>
                                        <Button type={'clear'} onClick={(event) => onClear(event)}>Clear</Button>
                                    </CBAction>
                                </div>}
                                {!policy && 'Loading...'}
                            </CBBody>


                        </ContentBox>
                    </form>
                </div>
            </Row>
        </Container>
    )
}

export default ChangePasswordView;
